<aside class="page-aside" style="min-width:14rem;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>Real-Time & Data</div>
	<ul style="display:flex;flex-direction:column;gap:var(--wa-spacing-x-small);list-style:none;margin:var(--wa-spacing-small) 0 0 0;padding:0;">
		<li>
			<a (click)="navigateTo('real-time')" href="javascript:void(0)" style="cursor:pointer;">Overview</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/communication-layers')" href="javascript:void(0)" style="cursor:pointer;">Communication Layers</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/rest-and-ajax')" href="javascript:void(0)" style="cursor:pointer;">REST & AJAX</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/data-services')" href="javascript:void(0)" style="cursor:pointer;">Data Services</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/vertx-event-bus')" href="javascript:void(0)" style="cursor:pointer;">Vert.x Event Bus</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/vertx-code-samples')" href="javascript:void(0)" style="cursor:pointer;">Vert.x Code Samples</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/rabbitmq')" href="javascript:void(0)" style="cursor:pointer;">RabbitMQ</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/rabbitmq-code-samples')" href="javascript:void(0)" style="cursor:pointer;">RabbitMQ Code Samples</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/use-cases')" href="javascript:void(0)" style="cursor:pointer;">Use Cases</a>
		</li>
		<li>
			<a (click)="navigateTo('real-time/choosing-a-pattern')" href="javascript:void(0)" style="cursor:pointer;">Choosing a Pattern</a>
		</li>
	</ul>
</aside>